// src/components/Support/TranslatedMessage.tsx
import React from "react";
import { ArrowPathIcon, LanguageIcon } from "@heroicons/react/24/outline";
import { useMessageTranslation } from "../../hooks/useMessageTranslation";

interface Props {
  message: string;
}

/**
 * Drop-in replacement for a plain message string inside a chat bubble.
 * Automatically translates into the active UI language and offers a
 * "show original / show translation" toggle on hover.
 */
const TranslatedMessage: React.FC<Props> = ({ message }) => {
  const { display, isTranslating, isTranslated, showOriginal, toggleOriginal } =
    useMessageTranslation(message);

  if (isTranslating) {
    return (
      <span className="inline-flex items-center gap-1.5">
        <span className="opacity-60">{message}</span>
        <ArrowPathIcon className="w-3 h-3 animate-spin text-gray-400 flex-shrink-0" />
      </span>
    );
  }

  if (!isTranslated) {
    return <>{message}</>;
  }

  return (
    <span className="relative group inline-block w-full">
      <span>{showOriginal ? message : display}</span>
      <button
        onClick={toggleOriginal}
        className="absolute -top-6 right-0 opacity-0 group-hover:opacity-100 transition-opacity
                   flex items-center gap-1 bg-black/60 text-[10px] text-gray-300
                   hover:text-orange-400 px-1.5 py-0.5 rounded whitespace-nowrap z-10"
      >
        <LanguageIcon className="w-3 h-3" />
        {showOriginal ? "Show translation" : "Show original"}
      </button>
    </span>
  );
};

export default TranslatedMessage;



